// extracted by mini-css-extract-plugin
export default {"savePassModal":"save-pass-modal_savePassModal__9604R"};